import styled from "styled-components"

import { media, mediaDown } from "styles/media"

export const H1 = styled.h1`
  font-size: 48px;

  ${mediaDown.small`
    font-size: 36px;
  `}
`

export const Title = styled.h2`
  font-family: "DharmaGothic";
  text-transform: uppercase;
  font-size: 60px;

  ${media.medium`
    font-size: 80px;
  `}

  ${media.large`
    font-size: 102px;
  `}
`

export const Subtitle = styled.h3`
  font-family: "GothamBold";
  font-size: 18px;
`
